import { render, staticRenderFns } from "./NationalPatentResponsibleForm.vue?vue&type=template&id=2cab7be4&"
import script from "./NationalPatentResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./NationalPatentResponsibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports